module.exports = __webpack_public_path__ + "media/V124.23b7b8e3.mp4";